var map = {
	"./webspecial_event_kirmes_cn.mp4": 406,
	"./webspecial_event_kirmes_de.mp4": 2644,
	"./webspecial_event_kirmes_en.mp4": 7776,
	"./webspecial_event_kirmes_ja.mp4": 2546,
	"./webspecial_event_kirmes_tr.mp4": 8231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8380;